export default "__VITE_ASSET__BCJqI69O__"